// Help Center articles. Keys are article ids; spread order matches FAQ_TOPICS.

import { GETTING_STARTED_ARTICLES } from 'src/services/consts/faq/topics/getting-started.const'
import { CONSENT_BANNERS_ARTICLES } from 'src/services/consts/faq/topics/consent-banners.const'
import { COOKIE_SCANNING_ARTICLES } from 'src/services/consts/faq/topics/cookie-scanning.const'
import { DEVELOPERS_ARTICLES } from 'src/services/consts/faq/topics/developers.const'
import { PRIVACY_BASICS_ARTICLES } from 'src/services/consts/faq/topics/privacy-basics.const'
import { ACCOUNT_AND_TEAM_ARTICLES } from 'src/services/consts/faq/topics/account-and-team.const'

/** @type {Record<string, import('src/services/helpers/faq/content.helper').FaqArticle>} */
export const FAQ_ARTICLES = {
  ...GETTING_STARTED_ARTICLES,
  ...CONSENT_BANNERS_ARTICLES,
  ...COOKIE_SCANNING_ARTICLES,
  ...DEVELOPERS_ARTICLES,
  ...PRIVACY_BASICS_ARTICLES,
  ...ACCOUNT_AND_TEAM_ARTICLES,
}

/**
 * Landing-page quick links - real article ids in onboarding order.
 */
export const FAQ_QUICK_LINKS = [
  { label: 'What is Cookie Armor?', articleId: 'what-is-cookie-armor' },
  { label: 'Set up your first banner', articleId: 'set-up-your-first-banner' },
  { label: 'Install the script', articleId: 'install-the-script' },
  { label: 'Run a scan', articleId: 'run-a-scan' },
  { label: 'Override a tracker category', articleId: 'classify-cookies' },
  { label: 'Configure banner behaviour', articleId: 'configure-banner-behaviour' },
]
